import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import {
  LOCALSTORAGE_REFRESH_TOKEN,
  LOCALSTORAGE_TOKEN,
  PATH_LOGIN,
} from './cst';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (
      localStorage.getItem(LOCALSTORAGE_TOKEN) ||
      localStorage.getItem(LOCALSTORAGE_REFRESH_TOKEN)
    ) {
      return true;
    }
    this.router.navigate([PATH_LOGIN]);
    return false;
  }
}
